import { SVGFC } from '@repo/toolkit/types'

const MenuBurgerIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.475 9.075H17.525C18.0636 9.075 18.5 8.6386 18.5 8.1C18.5 7.5614 18.0636 7.125 17.525 7.125H6.475C5.9364 7.125 5.5 7.5614 5.5 8.1C5.5 8.6386 5.9364 9.075 6.475 9.075Z"
        fill={color}
      />
      <path
        d="M17.525 11.0249H6.475C5.9364 11.0249 5.5 11.4613 5.5 11.9999C5.5 12.5385 5.9364 12.9749 6.475 12.9749H17.525C18.0636 12.9749 18.5 12.5385 18.5 11.9999C18.5 11.4613 18.0636 11.0249 17.525 11.0249Z"
        fill={color}
      />
      <path
        d="M17.525 14.9248H6.475C5.9364 14.9248 5.5 15.3612 5.5 15.8998C5.5 16.4384 5.9364 16.8748 6.475 16.8748H17.525C18.0636 16.8748 18.5 16.4384 18.5 15.8998C18.5 15.3612 18.0636 14.9248 17.525 14.9248Z"
        fill={color}
      />
    </svg>
  )
}

export default MenuBurgerIcon
